import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher, FaChevronDown } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OnePaymentRecord from '../ones/OnePaymentRecord';
import { MdCheck, MdSms, MdWhatsapp } from "react-icons/md";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import StaffRegistrationForm from "../ones/StaffRegistrationForm";
import IncomeRecordForm from "../ones/IncomeRecordForm";
import ExpenseRecordForm from "../ones/ExpenseRecordForm";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);	

	const [searchFilter, setSearchFilter] = useState("");

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			
		]);
		setReady(true);
	}

	

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		//..
	}, [appContext.allPaymentRecords])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
			<div
				className="container"
			>
				<div className="row">
					<div className="col-md-12">
						<h6 className="main-section-title">
							Reports
						</h6>
					</div>

					<div className="col-12 col-md-6 mt-3 mb-3">

						<button
							className="btn btn-outline btn-outline-dark btn-block font-regular"
							style={{
								padding: "20px",
								paddingTop: "40px",
								paddingBottom: "40px",
								fontSize: "20px",
								minHeight: "160px",
								textTransform: "uppercase",
							}}

							onClick={() => {
								appContext.navTo({
									item: 'view',
									subItem: 'classroom-debts-report'
								});
							}}
						>
							Classroom Debts Report
						</button>

					</div>

					<div className="col-12 col-md-6 mt-3 mb-3">

						<button
							className="btn btn-outline btn-outline-dark btn-block font-regular"
							style={{
								padding: "20px",
								paddingTop: "40px",
								paddingBottom: "40px",
								fontSize: "20px",
								minHeight: "160px",
								textTransform: "uppercase",
							}}

							onClick={() => {
								appContext.navTo({
									item: 'view',
									subItem: 'individual-payment-cycle-collection-report'
								});
							}}
						>
							Individual Payment Cycle Collection Report
						</button>

					</div>

					<div className="col-12 col-md-6 mt-3 mb-3">

						<button
							className="btn btn-outline btn-outline-dark btn-block font-regular"
							style={{
								padding: "20px",
								paddingTop: "40px",
								paddingBottom: "40px",
								fontSize: "20px",
								minHeight: "160px",
								textTransform: "uppercase",
							}}

							onClick={() => {
								appContext.navTo({
									item: 'view',
									subItem: 'general-payment-cycle-collection-report'
								});
							}}
						>
							General Payment Cycle Collection Report
						</button>

					</div>

					

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}